export const handleError = (error: any): void => {
  console.error('Error fetching commissions data:', error);
  // Logique de gestion des erreurs ou affichage des erreurs personnalisées
};
